import Component from '@glimmer/component'
import { service } from '@ember/service'
import type SubscriptionTypeService from 'teacher-ui-client/services/subscription-type'
import { Dialog } from 'teacher-ui-client/components/dialog'
import { eq } from 'ember-truth-helpers'
import { t } from 'ember-intl'
import { on } from '@ember/modifier'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'

interface Signature {
  Element: HTMLDivElement
  Args: {
    title?: string
    showModal?: boolean
    close: () => unknown
  }
  Blocks: {
    default: []
  }
}

export class LayoutBlocksModal extends Component<Signature> {
  @service subscriptionType!: SubscriptionTypeService

  <template>
    {{#if @showModal}}
      {{! Some of these older modals contain FormSelect dropdown components that are affected by overflow clipping.
      For the time being, allow overflow until they are replaced. }}
      <Dialog @onClose={{@close}} @showBackdrop={{true}} class="max-w-3xl min-w-lg overflow-visible rounded-lg">
        {{#if @title}}
          <h3
            data-test-layout-blocks-modal-header
            class="flex overflow-hidden rounded-t-lg p-4 text-white
              {{if (eq this.subscriptionType.current 'reading') 'bg-oceany-blue-300'}}
              {{if (eq this.subscriptionType.current 'maths') 'bg-ms-green-300'}}
              {{if (eq this.subscriptionType.current 'writing') 'bg-wl-blue-250'}}
              {{unless this.subscriptionType.current 'bg-black'}}"
          >
            {{@title}}
            <button
              type="button"
              class="ml-auto px-2"
              aria-label={{t "close"}}
              {{on "click" @close}}
              data-test-close-modal
            >
              <PhosphorIcon @icon="phosphor-x-bold" />
            </button>
          </h3>
        {{else}}
          <div class="flex p-4 text-black">
            <button
              type="button"
              class="ml-auto px-2"
              aria-label={{t "close"}}
              {{on "click" @close}}
              data-test-close-modal
            >
              <PhosphorIcon @icon="phosphor-x-bold" />
            </button>
          </div>
        {{/if}}
        <div ...attributes>
          {{yield}}
        </div>
      </Dialog>
    {{/if}}
  </template>
}

export default LayoutBlocksModal
